import { EventBus } from '@/plugins/event-bus'
import { displayConfirm } from '@/utils/swal'
import types from '@/utils/types'

export const nominatePhotoMixin = {
  data() {
    return {
      nominatePhotoBusy: false,
      nominatePhotoId: null
    }
  },
  methods: {
    nominatePhoto(event, photo) {
      event.preventDefault()
      if (!this.me || !this.me.id) {
        EventBus.$emit('snackbar', {
          text: 'You need to log in to nominate this photo',
          color: 'info'
        })
        return
      }
      if (this.me.id === photo.photographerId) {
        EventBus.$emit('snackbar', {
          text: 'You cannot nominate your own photos',
          color: 'info',
        })
        return
      }
      if (photo.statusName === types.photo.status.elite || photo.statusName === types.photo.status.inspiration) {
        EventBus.$emit('snackbar', {
          text: 'Elite and Inspiration photo cannot be nominated',
          color: 'info'
        })
        return
      }
      if (!this.$asa.canNominate()) {
        EventBus.$emit('snackbar', {
          text: 'An active membership or Grandmaster role is required to nominate this photo',
          color: 'info'
        })
        return
      }
      if (this.me.nominationAvailable === 0) {
        EventBus.$emit('snackbar', {
          text: "You don't have any Nomination available",
          color: 'info'
        })
        return
      }

      displayConfirm(
        'Are you sure you wish to Nominate this photo?',
        async result => {
          if (result.isConfirmed) {
            try {
              this.nominatePhotoBusy = true
              this.nominatePhotoId = photo.id
              const data = {
                id: photo.id
              }
              const response = await this.$axios.$post(`/photos/${photo.id}/nomination`, data)
              if (response) {
                EventBus.$emit('snackbar', {
                  text: 'The photo has been successfully nominated',
                  color: 'success'
                })
              } else {
                EventBus.$emit('snackbar', {
                  text: 'You already nominated this photo',
                  color: 'info'
                })
              }
              await this.$auth.fetchUser()
            } catch (error) {
              this.$asa.appInsights('Mixins: nominatePhotoMixin.js - method: nominatePhoto', error)
            } finally {
              this.nominatePhotoBusy = false
              this.nominatePhotoId = null
            }
          }
        }
      )
    }
  }
}
